// form
export { default as FormItem } from './item';

// 输入框
export { default as Input } from './input';

// 段落里加输入框
export { default as InputText } from './inputText';

// 多行输入
export { default as Textarea } from './textarea';

// 步进器
export { default as Stepper } from './stepper';

// 邮箱输入
export { default as Email } from './email';

// 隐藏框
export { default as Hidden } from './hidden';

// 选择器
export { default as Select } from './select';
// 选择器证件
export { default as SelectCert } from './selectCert';
// 选择器异步请求
export { default as SelectAsync } from './selectAsync';

// 选择器堆栈
export { default as PickerStack } from './pickerStack';

export { default as PickerStep } from './pickerStep';

// 单选框
export { default as Radio } from './radio';

// 联动单选框
export { default as RadioChild } from './radioChild';

// 健康告知
export { default as RadioHealth } from './radioHealth';

// 受益人
export { default as RadioPerson } from './radioPerson';

// 多选框
export { default as Checkbox } from './checkbox';

export { default as CheckboxChild } from './checkboxChild';

// 开关面板
export { default as SwitchPanel } from './switchPanel';

// 基本日期
export { default as Date } from './date';

// 验证码
export { default as Smscode } from './smscode';

// 协议
export { default as AgreeTerms } from './agreeTerms';

// 纯文字
export { default as Value } from './value';
// 子级列表文字
export { default as ValueChilds } from './valueChilds';
// 文字价格
export { default as ValuePrice } from './valuePrice';

// 上传文件
export { default as Upload } from './upload';
// 上传证件
export { default as UploadCertificate } from './uploadCertificate';

// 按钮
export { default as Button } from './button';
export { default as Submit } from './button';
// 按钮组
export { default as ButtonGroup } from './buttonGroup';
// 地址
export { default as Address } from './address';

// 地址
export { default as FormTemplate } from './formTemplate';
